/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ResponseObject,
  ResponseObject$inboundSchema,
  ResponseObject$Outbound,
  ResponseObject$outboundSchema,
} from "./responseobject.js";

export type ResponseFailedEvent = {
  type: "response.failed";
  sequenceNumber: number;
  response: ResponseObject;
};

/** @internal */
export const ResponseFailedEvent$inboundSchema: z.ZodType<
  ResponseFailedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.failed"),
  sequence_number: z.number().int(),
  response: ResponseObject$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
  });
});
/** @internal */
export type ResponseFailedEvent$Outbound = {
  type: "response.failed";
  sequence_number: number;
  response: ResponseObject$Outbound;
};

/** @internal */
export const ResponseFailedEvent$outboundSchema: z.ZodType<
  ResponseFailedEvent$Outbound,
  z.ZodTypeDef,
  ResponseFailedEvent
> = z.object({
  type: z.literal("response.failed"),
  sequenceNumber: z.number().int(),
  response: ResponseObject$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
  });
});

export function responseFailedEventToJSON(
  responseFailedEvent: ResponseFailedEvent,
): string {
  return JSON.stringify(
    ResponseFailedEvent$outboundSchema.parse(responseFailedEvent),
  );
}
export function responseFailedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseFailedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseFailedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseFailedEvent' from JSON`,
  );
}
